import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactMessageService {

  private apiUrl = `${environment.apiBaseUrl}/api/contact-messages`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getAll`);
  }

  getById(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.get(`${this.apiUrl}/getById`, { params });
  }

  markAsSolved(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.put(`${this.apiUrl}/markAsSolved`, {}, { params });
  }

  delete(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);
    return this.http.delete(`${this.apiUrl}/delete`, { params });
  }
}
